import {addComponentKeysets} from '../../../i18n';
import {NAMESPACE} from '../../utils/cn';

import en from './en.json';
import ru from './ru.json';

export default addComponentKeysets({en, ru}, `${NAMESPACE}user-label`);
